import * as React from "react"
import { Checkbox as CheckboxPrimitive } from "radix-ui"

import { cn } from "@/lib/utils"
import { IconCheck } from "@tabler/icons-react"

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        "tw:peer! tw:relative! tw:flex! tw:size-4! tw:shrink-0! tw:items-center! tw:justify-center! tw:rounded-lg! tw:border! tw:border-input! tw:transition-shadow! tw:outline-none tw:group-has-disabled/field:opacity-50! tw:after:absolute! tw:after:-inset-x-3! tw:after:-inset-y-2! tw:focus-visible:border-ring! tw:focus-visible:ring-2 tw:focus-visible:ring-ring/30 tw:disabled:cursor-not-allowed! tw:disabled:opacity-50! tw:aria-invalid:border-destructive! tw:aria-invalid:ring-2 tw:aria-invalid:ring-destructive/20 tw:aria-invalid:aria-checked:border-primary! tw:dark:bg-input/30! tw:dark:aria-invalid:border-destructive/50! tw:dark:aria-invalid:ring-destructive/40! tw:data-checked:border-primary! tw:data-checked:bg-primary! tw:data-checked:text-primary-foreground! tw:dark:data-checked:bg-primary!",
        className
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="tw:grid! tw:place-content-center! tw:text-current! tw:transition-none! tw:[&!>svg]:size-1.5"
      >
        <IconCheck
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
